<template>
    <div id="game-pop" @click="clickBlank($event)">
        <div class="blank-content"></div>
        <div class="rules-content" ref="blankPanel">
            <div v-show="popType == 2" class="rules-add list-wide-left">
                <div class="rules-add-text">
                    {{ $t("components.home.Select_Players") }}
                </div>
                <div class="rules-add-item">
                    <input
                        type="button"
                        :class="{
                            'rules-btn-selected': indexPlayers == 0,
                            'rules-btn': indexPlayers != 0,
                        }"
                        :value="addParams.players[0]"
                        @click="selectPlayer(0)"
                    />
                    <input
                        type="button"
                        :class="{
                            'rules-btn-selected': indexPlayers == 1,
                            'rules-btn': indexPlayers != 1,
                        }"
                        :value="addParams.players[1]"
                        @click="selectPlayer(1)"
                    />
                </div>
                <div class="rules-add-text">
                    {{ $t("components.home.Select_Game_Type") }}
                </div>
                <div class="rules-add-item">
                    <input
                        type="button"
                        :class="{
                            'rules-btn-selected': indexPool == 0,
                            'rules-btn': indexPool != 0,
                        }"
                        :value="addParams.pools[0] + ' Pool'"
                        @click="selectPool(0)"
                    />
                    <input
                        type="button"
                        :class="{
                            'rules-btn-selected': indexPool == 1,
                            'rules-btn': indexPool != 1,
                        }"
                        :value="addParams.pools[1] + ' Pool'"
                        @click="selectPool(1)"
                    />
                </div>
                <div class="rules-add-item">
                    <div
                        class="ico ico-rule-Info my-btn"
                        style="margin-left: 0.1rem; margin-top: 0.12rem"
                        @click="showHelper()"
                    ></div>
                </div>
            </div>
            <div
                class="rules-list"
                :class="{
                    'list-narrow-left list-narrow': popType == 2,
                    'list-wide-left list-wide': popType == 1,
                }"
                ref="popWrapper"
            >
                <div class="rules-lite-content" ref="popWrapperContainer">
                    <template v-for="(item, index) in list">
                        <div
                            v-if="isDemo == item.isDemo"
                            class="rules-lite-item"
                            @click="toGame(item, index)"
                            :key="index"
                        >
                            <img :src="item.img" />
                            <div class="item-points item-text">
                                {{ item.points }}
                            </div>
                            <div class="item-join item-text">
                                {{ item.join }}
                            </div>
                        </div>
                    </template>

                    <div v-show="popType == 1" class="rules-lite-help">
                        <div
                            class="ico ico-rule-Info my-btn"
                            style="margin-top: 0.12rem"
                            @click="showHelper()"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <MessageBox
            v-if="isShowMessageBox"
            :hasBtn="2"
            :title="$t('common.add_cash')"
            :body="$t('tips.You_do_not_have_enough_cash')"
            @on-left="gotoDeposit()"
            @on-right="playDemo()"
            @on-close="isShowMessageBox = false"
            :rightText="$t('common.play_demo')"
            :leftText="$t('common.Deposit')"
            :isShowClose="true"
        ></MessageBox>
    </div>
</template>
<script>
import dataConfig from "../../baseConfig/dataConfig";
import gamePopTools from "./game_pop_tools";
import ServerManager from "../../interface/server";
import tools from "../../utils/fun";
import AnalystManager from "../../utils/analyst";
import eventConfig from "../../baseConfig/eventConfig";
import MessageBox from "../common/modal_message_box";
export default {
    name: "game-pop",
    components: {
        MessageBox,
    },
    props: {
        configKey: { type: String, default: null },
        isDemo: { type: Boolean, default: false },
    },
    data() {
        return {
            _scroll: null,
            inHandler: null,
            popType: 1,
            indexPool: 0,
            indexPlayers: 0,
            gameId: 0,
            demoId: 0,
            addParams: {
                pools: [],
                players: [],
                keys: {},
            },
            list: [],
            isShowMessageBox: false
        };
    },
    beforeCreate() {},
    created() {
        this.initScroll();
    },
    mounted() {
    },
    watch: {
        configKey(newV, oldV) {
            if (newV != oldV) {
                let rlt = gamePopTools.getConfig(this, newV);
                this.popType = rlt.popType;

                this.gameId = rlt.gameId;
                this.demoId = rlt.demoId;
                console.log(" this.gameId", this.gameId);

                this.$store.commit("temp/setGameId", this.gameId);

                this.list = rlt.list;
                rlt.pools && (this.addParams.pools = rlt.pools);
                rlt.players && (this.addParams.players = rlt.players);
                rlt.keys && (this.addParams.keys = rlt.keys);
                this.$nextTick(() => {
                    gamePopTools.resetScroll(
                        this,
                        gamePopTools.getListLen(this.list, this.isDemo)
                    );
                });
            }
        },
    },
    methods: {
        playDemo() {
            console.log("playDemo");
            this.isDemo = true;

            let item = null;
            if (this.popType == 2) {
                item = {
                    id: 0,
                    img:tools.changeTowebp("/static/images/rules/base.webp?1.1.23"),
                    isDemo: true,
                    join: "Winnings: -",
                    pointNumber: 0,
                    points: "Entry Fee:free",
                };
            } else {
                if (this.configKey == "common_2Player") {
                    item = {
                        id: "403101",
                        img:tools.changeTowebp("/static/images/rules/base.webp?1.1.23"),
                        isDemo: true,
                        join: "join:free",
                        pointNumber: 10,
                        points: "point:10",
                    };
                } else {
                    item = {
                        id: "403102",
                        img:tools.changeTowebp("/static/images/rules/base.webp?1.1.23"),
                        isDemo: true,
                        join: "join:free",
                        pointNumber: 10,
                        points: "point:10",
                    };
                }
            }
            this.toGame(item, 4);
        },
        gotoDeposit() {
            tools.toPage(this, { path: "/deposit" });
        },
        showHelper() {
            this.$emit("on-helper");
        },
        clickBlank(e) {
            if (!this.$refs.blankPanel.contains(e.target)) {
                this.onClose();
            }
        },
        onClose() {
            this.$emit("on-close");
        },
        clearInHandler() {
            if (this.inHandler) {
                clearInterval(this.inHandler);
            }
            this.inHandler = null;
        },
        initScroll() {
            this.clearInHandler();
            this.inHandler = setInterval(() => {
                if (this.$refs.popWrapper) {
                    this.clearInHandler();
                    gamePopTools.initScroll(this);
                    gamePopTools.resetScroll(
                        this,
                        gamePopTools.getListLen(this.list, this.isDemo)
                    );
                }
            }, 50);
        },
        selectPlayer(index) {
            this.indexPlayers = index;
            if (this.popType == 2) {
                gamePopTools.resetWinings(this, this.list, index);
            }
        },
        selectPool(index) {
            this.indexPool = index;
        },
        toFactGame(roomId) {
            let gid = this.isDemo ? this.demoId : this.gameId;
            ServerManager.getGameUrl(
                this,
                gid,
                roomId,
                this.isDemo,
                (data) => {
                    setTimeout(() => {
                        window.location.href = data.loginUrl + "&isBack=1";
                    }, 1000);
                    //进入游戏，清理预充值标记，避免统计错误
                    this.$store && this.$store.commit("user/setPayMoney" , 0);
                    //进入游戏成功
                    AnalystManager.event(
                        this,
                        eventConfig.google.home.EVENT,
                        eventConfig.google.home.actionRoomEnd(this.isDemo),
                        this.configKey
                    );
                },
                (err) => {
                    tools.setLoadingState(false);
                    if (err == "2001") {
                        this.isShowMessageBox = true;
                    } else {
                        this.$toast.show(this.$t("err." + err));
                    }
                }
            );
        },
        toGame(item, index) {
            if (this.popType == 2) {
                var key = "i" + this.indexPlayers;
                key += this.indexPool;
                key += index;
                if (this.addParams.keys[key]) {
                    item.id = this.addParams.keys[key];
                }
            }
            tools.setLoadingState(true);
            // demo 非登录状态，使用游客
            if (this.isDemo && !this.$store.state.user.isLogin) {
                let guest = this.$store.getters["user/getGuest"](
                    this.$store.getters["common/getCountry"]
                );
                if (!guest) {
                    ServerManager.getGuestAccountJson(
                        this,
                        (data) => {
                            this.toFactGame(item.id);
                        },
                        (err) => {
                            tools.setLoadingState(false);
                            this.$toast.show(err);
                        }
                    );
                } else {
                    this.toFactGame(item.id);
                }
            } else {
                ServerManager.getUserInfo(
                    this,
                    (resData) => {
                        this.toFactGame(item.id);
                    },
                    (error) => {
                        tools.setLoadingState(false);
                    }
                );
            }
            //选择进入游戏
            AnalystManager.event(
                this,
                eventConfig.google.home.EVENT,
                eventConfig.google.home.actionRoomSel(this.isDemo),
                this.configKey
            );
        },
    },
};
</script>
<style lang="less" scoped>
#game-pop {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 4;

    .blank-content {
        margin: 0 auto;
        width: 1334px;
        height: 390px;
    }

    .rules-content {
        margin: 0 auto;
        width: 1334px;
        height: 360px;
        display: flex;
        align-items: center;
        border-top: solid 2px #f82e49;
        background: rgba(0, 0, 0, 0.7);
    }

    @rulesAddWidth: 280px;

    .rules-add {
        position: relative;
        float: left;
        width: @rulesAddWidth;

        .rules-add-item {
            height: 60px;
            padding: 5px 0px;
            color: #d3d1d5;
            font-size: 26px;
        }

        .rules-add-text {
            height: 32px;
            line-height: 32px;
            color: #d3d1d5;
            font-size: 26px;
        }

        .rules-btn {
            width: 128px;
            height: 60px;
            background: rgba(0, 0, 0, 0.5);
            border: 0.03rem solid #f82e49;
            border-radius: 0.15rem;
            color: #ffffff;
            font-size: 26px;
        }

        .rules-btn-selected {
            width: 128px;
            height: 60px;
            background: #f82e49;
            border: 0.03rem solid #ffffff;
            border-radius: 0.15rem;
            color: #ffffff;
            text-align: center;
            font-size: 26px;
        }
    }

    .rules-list {
        position: relative;
        float: left;
        overflow: hidden;

        .rules-lite-content {
            position: relative;
            float: left;
            height: 302px;
            width: 95%;
            display: flex;

            .rules-lite-item {
                position: relative;
                width: 260px;
                height: 302px;
                border-radius: 20px;
                border: 0;
                margin: 0px 20px 0px 0px;

                .item-points {
                    position: absolute;
                    bottom: 52px;
                }

                .item-join {
                    position: absolute;
                    bottom: 12px;
                }

                .item-text {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    font-size: 26px;
                    text-align: center;
                    color: #ffffff;
                }
            }

            .rules-lite-item img {
                width: 260px;
                height: 302px;
                border-radius: 20px;
                border: 0;
            }
        }
    }

    @wideLeft: 75px;
    .list-wide-left {
        margin-left: @wideLeft;
    }

    .list-wide {
        width: 1334px - @wideLeft;
    }

    @narrowLeft: 30px;
    .list-narrow-left {
        margin-left: @narrowLeft;
    }

    .list-narrow {
        width: 1334px - @narrowLeft - @rulesAddWidth;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/home/game_pop.vue